import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { Subscription } from 'rxjs';

import { AudioLevelComponent } from '../../../../components/precall/audio-level/audio-level.component';
import { CompatibilityCardComponent } from '../../../../components/precall/compatibility-card/compatibility-card.component';
import { ConnectivityTestService } from '../../../../core/services/connectivity-test.service';
import { ProcallConnectivityStep } from '../../../../models/app/precall/precall-connectivity-step';
import { TaskStateComponent } from '../../../../components/precall/task-state/task-state.component';

@Component({
  selector: 'app-precall-conectivity-step',
  imports: [CompatibilityCardComponent, AudioLevelComponent, TaskStateComponent, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './precall-conectivity-step.component.html',
})
export class PrecallConectivityStepComponent implements OnInit, OnDestroy {
  connectivityService = inject(ConnectivityTestService);

  resultTestSubscription: Subscription | undefined;
  videoSessionSubscription: Subscription | undefined;
  result = signal<ProcallConnectivityStep | undefined>(undefined);

  ngOnInit(): void {
    this.resultTestSubscription = this.connectivityService.store.data$.subscribe(
      this.onConnectivityTestChange.bind(this),
    );
    // Connectivity test is managed by the parent component
  }

  ngOnDestroy(): void {
    this.resultTestSubscription?.unsubscribe();
  }

  onConnectivityTestChange(result: ProcallConnectivityStep | undefined) {
    this.result.set(result);
  }
}
